import { CustomGroupsStateInterface } from '../../models';

export const customGroupsInitialState: CustomGroupsStateInterface = {
  customGroups: [],
  customGroupsEntities: {},
  error: undefined,
  isLoading: false,
  isLoaded: false
};
